import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api } from "@/lib/api";

const INPUT = "w-full px-3 py-2.5 rounded-xl border border-[#D5CCBC] bg-white text-sm text-[#1E2B1D] focus:outline-none focus:ring-2 focus:ring-[#3D5A40]";
const LABEL = "block text-xs font-bold uppercase tracking-wider text-[#354634] mb-1.5";

export default function AccountSettings({ user, onUpdated }) {
  const [form, setForm] = useState({ new_email: user?.email || "", new_password: "", confirm: "", current_password: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password && form.new_password !== form.confirm) {
      toast.error("Konfirmasi kata sandi tidak sama");
      return;
    }
    setSaving(true);
    try {
      const payload = { current_password: form.current_password };
      if (form.new_email.trim().toLowerCase() !== (user?.email || "")) payload.new_email = form.new_email;
      if (form.new_password) payload.new_password = form.new_password;
      const { data } = await api.put("/auth/account", payload);
      localStorage.setItem("puspita_admin_token", data.token);
      toast.success(
        data.changed.includes("password_hash") && data.changed.includes("email")
          ? "Email dan kata sandi admin diperbarui"
          : data.changed.includes("email") ? "Email admin diperbarui" : "Kata sandi admin diperbarui"
      );
      setForm({ new_email: data.user.email, new_password: "", confirm: "", current_password: "" });
      onUpdated?.(data.user);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Gagal memperbarui akun");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="account-settings" className="bg-[#FBF9F5] rounded-2xl border border-[#E8E2D5] p-6 space-y-4">
      <div className="flex items-center gap-2">
        <KeyRound className="w-4 h-4 text-[#3D5A40]" />
        <span className="text-sm font-bold text-[#1E2B1D]">Akun Admin</span>
      </div>
      <p className="text-xs text-[#6B7C66]">Ubah email login dan/atau kata sandi. Wajib memasukkan kata sandi saat ini untuk konfirmasi.</p>
      <div>
        <label className={LABEL}>Email Login</label>
        <input type="email" required value={form.new_email} onChange={set("new_email")} data-testid="account-email-input" className={INPUT} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className={LABEL}>Kata Sandi Baru</label>
          <input type="password" value={form.new_password} onChange={set("new_password")} data-testid="account-new-password-input" placeholder="Kosongkan jika tidak diganti" minLength={8} className={INPUT} />
        </div>
        <div>
          <label className={LABEL}>Konfirmasi Kata Sandi Baru</label>
          <input type="password" value={form.confirm} onChange={set("confirm")} data-testid="account-confirm-password-input" placeholder="Ulangi kata sandi baru" className={INPUT} />
        </div>
      </div>
      <div className="max-w-xs">
        <label className={LABEL}>Kata Sandi Saat Ini</label>
        <input type="password" required value={form.current_password} onChange={set("current_password")} data-testid="account-current-password-input" className={INPUT} />
      </div>
      <button
        type="submit"
        disabled={saving}
        data-testid="account-save-btn"
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border border-[#3D5A40] text-[#3D5A40] hover:bg-[#EAF2E9] disabled:opacity-50 font-bold text-sm transition-colors"
      >
        {saving ? "Menyimpan..." : "Perbarui Akun Admin"}
      </button>
    </form>
  );
}
